"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultOracleAPI = void 0;
const big_js_1 = __importDefault(require("big.js"));
const bn_js_1 = __importDefault(require("bn.js"));
const utils_1 = require("../utils");
const transaction_1 = require("./transaction");
const defaultFeedName = "DOT/BTC";
class DefaultOracleAPI extends transaction_1.DefaultTransactionAPI {
    constructor(api, account) {
        super(api, account);
    }
    convertSatoshiToPlanck(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const planckPerSatoshi = yield this.getRawExchangeRate();
            const amountSatoshiBig = new big_js_1.default(amount.toString());
            return new bn_js_1.default(planckPerSatoshi.mul(amountSatoshiBig).toString());
        });
    }
    convertBitcoinToDot(amount) {
        return __awaiter(this, void 0, void 0, function* () {
            const dotPerBtc = yield this.getExchangeRate();
            return dotPerBtc.mul(amount);
        });
    }
    getExchangeRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const rawRate = yield this.getRawExchangeRate();
            return new big_js_1.default(this.convertFromRawExchangeRate(rawRate));
        });
    }
    getOnlineTimeout() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const moment = yield this.api.query.exchangeRateOracle.maxDelay.at(head);
            return moment.toNumber();
        });
    }
    getRawExchangeRate() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const encodedRawRate = yield this.api.query.exchangeRateOracle.exchangeRate.at(head);
            return new big_js_1.default(utils_1.decodeFixedPointType(encodedRawRate));
        });
    }
    setExchangeRate(dotPerBtc) {
        return __awaiter(this, void 0, void 0, function* () {
            const encodedExchangeRate = utils_1.encodeUnsignedFixedPoint(this.api, dotPerBtc);
            const tx = this.api.tx.exchangeRateOracle.setExchangeRate(encodedExchangeRate);
            yield this.sendLogged(tx, this.api.events.exchangeRateOracle.SetExchangeRate);
        });
    }
    getBtcTxFeesPerByte() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const fees = yield this.api.query.exchangeRateOracle.satoshiPerBytes.at(head);
            return { fast: fees.fast.toNumber(), half: fees.half.toNumber(), hour: fees.hour.toNumber() };
        });
    }
    setBtcTxFeesPerByte({ fast, half, hour }) {
        return __awaiter(this, void 0, void 0, function* () {
            [fast, half, hour].forEach((param) => {
                const big = new big_js_1.default(param);
                if (!big.round().eq(big)) {
                    throw new Error("tx fees must be an integer amount of satoshi");
                }
                if (big.lt(0)) {
                    throw new Error("tx fees must be a positive amount of satoshi");
                }
            });
            const tx = this.api.tx.exchangeRateOracle.setBtcTxFeesPerByte(fast, half, hour);
            yield this.sendLogged(tx, this.api.events.exchangeRateOracle.SetBtcTxFeesPerByte);
        });
    }
    getSourcesById() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const oracles = yield this.api.query.exchangeRateOracle.authorizedOracles.entriesAt(head);
            const nameMap = new Map();
            oracles.forEach((oracle) => nameMap.set(utils_1.storageKeyToFirstInner(oracle[0]).toString(), oracle[1].toUtf8()));
            return nameMap;
        });
    }
    getFeed() {
        return Promise.resolve(defaultFeedName);
    }
    getLastExchangeRateTime() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const moment = yield this.api.query.exchangeRateOracle.lastExchangeRateTime.at(head);
            return this.convertMoment(moment);
        });
    }
    isOnline() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const errors = yield this.api.query.security.errors.at(head);
            return !this.hasOracleError(errors);
        });
    }
    hasOracleError(errors) {
        for (const error of errors.values()) {
            if (error.isOracleOffline) {
                return true;
            }
        }
        return false;
    }
    convertMoment(moment) {
        return new Date(moment.toNumber());
    }
    // Converts the raw exchange rate (Planck to Satoshi) into
    // DOT to BTC
    convertFromRawExchangeRate(rate) {
        const divisor = new big_js_1.default(utils_1.DOT_IN_PLANCK / utils_1.BTC_IN_SAT);
        return rate.div(divisor);
    }
}
exports.DefaultOracleAPI = DefaultOracleAPI;
//# sourceMappingURL=oracle.js.map